import { useProductPlanI18nFormModelContext } from "../../../../../../model";
import { useProductExistingPlanI18nFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel } = useProductPlanI18nFormModelContext();
	const { onUpdate } = useProductExistingPlanI18nFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
